export const SET_SELECTED_PLAN = 'SET_SELECTED_PLAN'
export const SET_FIELD_TEXT = 'SET_FIELD_TEXT'
export const ACTIVATE_ACCOUNT = 'ACTIVATE_ACCOUNT'
export const ACTIVATE_ACCOUNT_SENT = 'ACTIVATE_ACCOUNT_SENT'
export const ACTIVATE_ACCOUNT_SUCCESS = 'ACTIVATE_ACCOUNT_SUCCESS'
export const ACTIVATE_ACCOUNT_FAILED = 'ACTIVATE_ACCOUNT_FAILED'
export const ACTIVATE_ACCOUNT_INTERNAL = 'ACTIVATE_ACCOUNT_INTERNAL'
export const ACTIVATE_INTERNAL_ACCOUNT_SENT = 'ACTIVATE_INTERNAL_ACCOUNT_SENT'
export const ACTIVATE_INTERNAL_ACCOUNT_SUCCESS = 'ACTIVATE_INTERNAL_ACCOUNT_SUCCESS'
export const ACTIVATE_INTERNAL_ACCOUNT_FAILED = 'ACTIVATE_INTERNAL_ACCOUNT_FAILED'
export const RESET_ACTIVATE_ACCOUNT_FORM = 'RESET_ACTIVATE_ACCOUNT_FORM'
export const SET_ACTIVATE_LOADING_SPINNER = 'SET_ACTIVATE_LOADING_SPINNER'
export const SET_CHANGE_CARD_MODE = 'SET_CHANGE_CARD_MODE'
export const UPDATE_ACCOUNT_ACTIVATION = 'UPDATE_ACCOUNT_ACTIVATION'
export const UPDATE_ACCOUNT_ACTIVATION_SUCCESS = 'UPDATE_ACCOUNT_ACTIVATION_SUCCESS'
export const UPDATE_ACCOUNT_ACTIVATION_FAILED = 'UPDATE_ACCOUNT_ACTIVATION_FAILED'
